module.exports = __webpack_public_path__ + "img/avatar-11.23d1076e.png";